<!-- my-component.vue -->
<template>
<!-- Button trigger modal -->
<div>
    <div v-if="landing_map" class="landing-map">
        <div class="row" style="width:100%;margin-left:0px;padding-top:100px;">
            <div class="hidden-cs col-md-2"></div>
            <div class="col-12 col-md-6">
                <h1 class="title-landing">Locate your data</h1>
                <h1 class="subtitle-landing">Add a map visualisation to your marketplace, events, shops...</h1>
                <button v-on:click='app_map = true;landing_map=false' class="button-app-map">Discover</button>


            </div>
            <div class="col-12 col-md-4" style="text-align:center;">
                <img :src="map_app" style="width:60%;margin-top:20px;margin-bottom:20px;">
            </div>
           
            
        </div>
        
    </div>

    <div v-if="app_map" class="app-map">
        <div class="row" style="width:100%;margin-left:0px;">
            <!--
            <div v-if="liste_event" class="col-12 col-md-3 section-events">
                <div style="padding-bottom:30px">
              <div class="card-event"></div>
              <div class="card-event"></div>
              <div class="card-event"></div>
              <div class="card-event"></div>
              <div class="card-event"></div>
              <div class="card-event"></div>
              <div class="card-event"></div>
              <div class="card-event"></div>
              <div class="card-event"></div>
                </div>
            </div>
            -->
            <div v-on:click='app_map = false;landing_map=true' class="button-retour">
                <img :src="retour" style="width:50px">
            </div>
            <div v-if="map_event" class="col-12  col-md-1 nopadding"></div>
            <div v-if="map_event" class="col-12  col-md-3 nopadding">
            <div v-if="map_event" class="col-12  col-md-6 nopadding"></div>
                <vue-google-autocomplete
                    id="map"
                    classname="form-control"
                    placeholder="Search"
                    v-on:placechanged="getAddressData"
                    style="background-color:white;position:fixed;z-index:13;top:100px;width:400px;margin-top:6px;"
                >
                </vue-google-autocomplete>
            </div>
            <div v-if="map_event" class="col-12  col-md-12 nopadding section-map">

                    <gmap-map
                        :center="center"
                        :zoom="zoom"
                        :options="{
                            styles: styles,
                            mapTypeControl: false,
                            streetViewControl:false,
                            zoomControlOptions: {
                                position: 'ControlPosition.LEFT_CENTER'
                            }
                        }"
                        class="map"
                    >

                        <gmap-marker
                        :icon="{url:'/src/assets/img/home/location.svg'}"
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :clickable="true"
                        :draggable="false"
                        @click="toggleInfoWindow(m,index)"
                        ></gmap-marker>
                        <gmap-info-window :options="infoOptions" 
                            :position="infoWindowPos" 
                            :opened="infoWinOpen" 
                             
                            @closeclick="infoWinOpen=false"
                          
                        >
                        <div class="row" style="margin-left:0px;width:100%;background-color:white;color:#16466B;border-radius:5px;">
                            <div class="col-md-12" style="margin-left:0px;text-align:center">
                                <img :src="picture_event" style="width:100px;margin-top:20px;margin-bottom:20px;">
                                <h1 style="font-size:30px;margin:10px;">{{titre_event}}</h1>
                            </div>
                        </div>
                        </gmap-info-window>
                    </gmap-map>
            </div>
            <div class="col-12 hidden-md button-option">
                <div class="row" style="width:100%;margin-left:0px;">
                    <div class="col-1"></div>
                    <div class="col-4">
                        <button v-on:click='liste_event = true;map_event=false' class="button-app-map">Liste</button>
                    </div>
                    <div class="col-4">
                        <button v-on:click='liste_event = false;map_event=true' class="button-app-map">Map</button>
                    </div>
                    <div class="col-3"></div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script scoped>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
    components: { VueGoogleAutocomplete },
data() {
  return {
    address:'',
    titre_event: '',
    picture_event : '',
    infoWindowPos: {
    lat: 0,
    lng: 0
    },
    infoWinOpen: false,
    currentMidx: null,
    //optional: offset infowindow so it visually sits nicely on top of our marker
    infoOptions: {
    pixelOffset: {
        width: 0,
        height: -35
    }
    },
    app_map: false,
    landing_map:true,
    liste_event:true,
    map_event:true,
    isShowMyModal: false,
    wave: require('./assets/img/app/wave2.svg'),
    retour: require('./assets/img/app/retour.svg'),
    map_app: require('./assets/img/app/map.png'),
    zoom : 4,
    center: {lat: 50.227638, lng: 20.213749},
    markers: [{
        position: {lat: 45.0, lng: 0.0},
        infoText: 'Product 1',
        picture_event: require('./assets/img/app/wave2.svg'),
    },
    {
        position: {lat: 50.0, lng: 20.0},
        infoText: 'Product 2',
        picture_event: require('./assets/img/home/trefle_bottom.svg'),
    },
     {
        position: {lat: 60.0, lng: 11.0},
        infoText: 'Product 3',
        picture_event: require('./assets/img/app/map.png'),
    }],
    styles:[
        {
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#ebe3cd"
            },
            {
                "weight": 0.5
            }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#523735"
            }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
            {
                "color": "#f5f1e6"
            }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#c9b2a6"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#dcd2be"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#ae9e90"
            }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "color": "#6ddfd4"
            },
            {
                "weight": 6.5
            }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#93817c"
            }
            ]
        },
        {
            "featureType": "poi.business",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "color": "#a5b076"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#447530"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#f5f1e6"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "road.arterial",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#fdfcf8"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#f8c967"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#e9bc62"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#e98d58"
            }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#db8555"
            }
            ]
        },
        {
            "featureType": "road.local",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#806b63"
            }
            ]
        },
        {
            "featureType": "transit",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#8f7d77"
            }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "labels.text.stroke",
            "stylers": [
            {
                "color": "#ebe3cd"
            }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "color": "#b9d3c2"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#92998d"
            }
            ]
        }
    ]
  }
},
    methods: {
    toggleInfoWindow: function(marker, idx) {
        console.log('yo map')
        console.log(marker.position)
        console.log(marker.infoText)
        this.$data.infoWindowPos = marker.position;
        this.$data.titre_event = marker.infoText;
        this.$data.picture_event = marker.picture_event;

        //console.log(this.$data.infoContent)

        //check if its the same marker that was selected if yes toggle
        if (this.$data.currentMidx == idx) {
            this.$data.infoWinOpen = !this.$data.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
            this.$data.infoWinOpen = true;
            this.$data.currentMidx = idx;
        }
    },
    getAddressData: function (addressData, placeResultData, id) {
        this.$data.address = addressData;
        this.$data.center.lat = addressData.latitude
        this.$data.center.lng = addressData.longitude
        this.$data.zoom = 10
        console.log(addressData.longitude)
    }
  }
  }

</script>
<style scoped>

.button-retour{
    position:absolute;z-index:14;height:20;width:20;margin-top:100px;margin-left:30px;
}

.button-retour:hover{
    cursor: pointer;
}

.button-app-map{
    margin-top:15px;
    background-color:#2452C1;
    border-radius:4px;    
    color:white;
    width:100px;
    height:35px;
}
.button-app-map:hover{
    cursor: pointer;
    background-color:#537CDF;
}

.card-event{
    width:100%;
    background-color:white;
    height: 170px;
    border-radius:5px;
    margin-top:10px;
/* Rectangle 28: */
border: 1px solid #979797;

}





.app-map{
    position:fixed;
    background-color:white;
    width:100%;height:100vh;top:0;
}


/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}
.section-events{
    background-color:white;
    width:100%;
    height:100vh;
    overflow-y:scroll;
    margin-top:60px;
    padding-bottom:60px;
}

.button-option{
    position: fixed;
    bottom:20px;
    height:60px;

    margin:0px;
    text-align:center;
}
.section-map{
    width:100%;
    height:100vh;
    margin-top:40px;
}
.map{
    width:100%;
    height:100vh;
    margin-left:0px;
    margin:0;
    position: fixed;
    margin-top:25px;

}
.landing-map{
/* Rectangle 23: */
background-image: linear-gradient(-180deg, #99C2EF 0%, #70A4DE 100%);
    width:100%;height:auto;top:0;
}
}

/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}

.section-events{
    background-color:white;
    width:100%;
    height:100vh;
    overflow-y:scroll;
    margin-top:60px;
    padding-bottom:60px;
}
.section-map{
    width:100%;
    height:100vh;
    margin-top:60px;
}
.map{
    width:100%;
    height:95vh;
    margin-left:0px;
    margin:0;
    position: fixed;
    margin-top:58px;

}
.landing-map{
/* Rectangle 23: */
background-image: linear-gradient(-180deg, #99C2EF 0%, #70A4DE 100%);
    width:100%;height:100vh;top:0;
}
}


.card-price{
  width:96%;
  height: 400px;
  background-color:white;
  border-radius:5px;
  position: center;
  margin-top:15px;
}

.title-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
padding-top:100px;
font-weight:normal;
}
.subtitle-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(233, 232, 232);
font-size:30px;
padding-top:10px;
font-weight:normal;
}

.nopadding {
   padding: 0 !important;
   margin: 0 !important;
}

</style>


// WEBPACK FOOTER //
// src/map.vue